import { render, staticRenderFns } from "./payment-methods-input.vue?vue&type=template&id=5d3df57c&"
import script from "./payment-methods-input.vue?vue&type=script&lang=js&"
export * from "./payment-methods-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports